/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '../../common/interfaces';

export enum PageNodeFormInputs {
  Extension = 'extension',
  Slug = 'slug',
  ParentNodeId = 'parentNodeId',
  SiteId = 'siteId'
}

export type PageNodeFormFields = FormFields<typeof PageNodeFormInputs>;

export type PageNodeFormValidationSchema = FormValidationSchema<PageNodeFormFields>;

export enum PageNodeExtension {
  HTML = 'html',
  HTM = 'htm',
  PHP = 'php'
}
